import { default as indexiVM30bG64vMeta } from "/home/msservice/workspace/MAYBE/STG/STG-MAYBE-V3-FE/maybe-v3-fe-stg/pages/[slug]/index.vue?macro=true";
import { default as _404KTHfpT4WEKMeta } from "/home/msservice/workspace/MAYBE/STG/STG-MAYBE-V3-FE/maybe-v3-fe-stg/pages/404.vue?macro=true";
import { default as indexq2WI26bkRoMeta } from "/home/msservice/workspace/MAYBE/STG/STG-MAYBE-V3-FE/maybe-v3-fe-stg/pages/account-trial/index.vue?macro=true";
import { default as indexFDMmIQvnbRMeta } from "/home/msservice/workspace/MAYBE/STG/STG-MAYBE-V3-FE/maybe-v3-fe-stg/pages/account/index.vue?macro=true";
import { default as indexDTV2hCVPTDMeta } from "/home/msservice/workspace/MAYBE/STG/STG-MAYBE-V3-FE/maybe-v3-fe-stg/pages/dua-top-ngoai-hang-anh/index.vue?macro=true";
import { default as eventWTfNJxN1BZMeta } from "/home/msservice/workspace/MAYBE/STG/STG-MAYBE-V3-FE/maybe-v3-fe-stg/pages/event.vue?macro=true";
import { default as indexhGde7g6hQlMeta } from "/home/msservice/workspace/MAYBE/STG/STG-MAYBE-V3-FE/maybe-v3-fe-stg/pages/huong-dan/index.vue?macro=true";
import { default as indexd9xc5BUHpvMeta } from "/home/msservice/workspace/MAYBE/STG/STG-MAYBE-V3-FE/maybe-v3-fe-stg/pages/index.vue?macro=true";
import { default as indexgr5hirJUtTMeta } from "/home/msservice/workspace/MAYBE/STG/STG-MAYBE-V3-FE/maybe-v3-fe-stg/pages/khuyen-mai/index.vue?macro=true";
import { default as indexswcJvJ1eXJMeta } from "/home/msservice/workspace/MAYBE/STG/STG-MAYBE-V3-FE/maybe-v3-fe-stg/pages/live-casino/index.vue?macro=true";
import { default as lobby_45gameHsaC3bv6TfMeta } from "/home/msservice/workspace/MAYBE/STG/STG-MAYBE-V3-FE/maybe-v3-fe-stg/pages/lobby-game.vue?macro=true";
import { default as maintenanceSiS9cGre63Meta } from "/home/msservice/workspace/MAYBE/STG/STG-MAYBE-V3-FE/maybe-v3-fe-stg/pages/maintenance.vue?macro=true";
import { default as indextizMGUyWhjMeta } from "/home/msservice/workspace/MAYBE/STG/STG-MAYBE-V3-FE/maybe-v3-fe-stg/pages/the-thao/index.vue?macro=true";
import { default as lich_45thi_45dauv86XvPEc9HMeta } from "/home/msservice/workspace/MAYBE/STG/STG-MAYBE-V3-FE/maybe-v3-fe-stg/pages/the-thao/lich-thi-dau.vue?macro=true";
import { default as index1Nh5abp2hzMeta } from "/home/msservice/workspace/MAYBE/STG/STG-MAYBE-V3-FE/maybe-v3-fe-stg/pages/tin-tuc/index.vue?macro=true";
import { default as indextuRaS98yTwMeta } from "/home/msservice/workspace/MAYBE/STG/STG-MAYBE-V3-FE/maybe-v3-fe-stg/pages/vong-quay-ma-quai/index.vue?macro=true";
export default [
  {
    name: "slug",
    path: "/:slug()",
    meta: indexiVM30bG64vMeta || {},
    component: () => import("/home/msservice/workspace/MAYBE/STG/STG-MAYBE-V3-FE/maybe-v3-fe-stg/pages/[slug]/index.vue").then(m => m.default || m)
  },
  {
    name: "404",
    path: "/404",
    component: () => import("/home/msservice/workspace/MAYBE/STG/STG-MAYBE-V3-FE/maybe-v3-fe-stg/pages/404.vue").then(m => m.default || m)
  },
  {
    name: "account-trial",
    path: "/account-trial",
    component: () => import("/home/msservice/workspace/MAYBE/STG/STG-MAYBE-V3-FE/maybe-v3-fe-stg/pages/account-trial/index.vue").then(m => m.default || m)
  },
  {
    name: "account",
    path: "/account",
    meta: indexFDMmIQvnbRMeta || {},
    component: () => import("/home/msservice/workspace/MAYBE/STG/STG-MAYBE-V3-FE/maybe-v3-fe-stg/pages/account/index.vue").then(m => m.default || m)
  },
  {
    name: "dua-top-ngoai-hang-anh",
    path: "/dua-top-ngoai-hang-anh",
    component: () => import("/home/msservice/workspace/MAYBE/STG/STG-MAYBE-V3-FE/maybe-v3-fe-stg/pages/dua-top-ngoai-hang-anh/index.vue").then(m => m.default || m)
  },
  {
    name: "event",
    path: "/event",
    component: () => import("/home/msservice/workspace/MAYBE/STG/STG-MAYBE-V3-FE/maybe-v3-fe-stg/pages/event.vue").then(m => m.default || m)
  },
  {
    name: "huong-dan",
    path: "/huong-dan",
    component: () => import("/home/msservice/workspace/MAYBE/STG/STG-MAYBE-V3-FE/maybe-v3-fe-stg/pages/huong-dan/index.vue").then(m => m.default || m)
  },
  {
    name: "index",
    path: "/",
    meta: indexd9xc5BUHpvMeta || {},
    component: () => import("/home/msservice/workspace/MAYBE/STG/STG-MAYBE-V3-FE/maybe-v3-fe-stg/pages/index.vue").then(m => m.default || m)
  },
  {
    name: "khuyen-mai",
    path: "/khuyen-mai",
    component: () => import("/home/msservice/workspace/MAYBE/STG/STG-MAYBE-V3-FE/maybe-v3-fe-stg/pages/khuyen-mai/index.vue").then(m => m.default || m)
  },
  {
    name: "live-casino",
    path: "/live-casino",
    component: () => import("/home/msservice/workspace/MAYBE/STG/STG-MAYBE-V3-FE/maybe-v3-fe-stg/pages/live-casino/index.vue").then(m => m.default || m)
  },
  {
    name: "lobby-game",
    path: "/lobby-game",
    component: () => import("/home/msservice/workspace/MAYBE/STG/STG-MAYBE-V3-FE/maybe-v3-fe-stg/pages/lobby-game.vue").then(m => m.default || m)
  },
  {
    name: "maintenance",
    path: "/maintenance",
    component: () => import("/home/msservice/workspace/MAYBE/STG/STG-MAYBE-V3-FE/maybe-v3-fe-stg/pages/maintenance.vue").then(m => m.default || m)
  },
  {
    name: "the-thao",
    path: "/the-thao",
    component: () => import("/home/msservice/workspace/MAYBE/STG/STG-MAYBE-V3-FE/maybe-v3-fe-stg/pages/the-thao/index.vue").then(m => m.default || m)
  },
  {
    name: "the-thao-lich-thi-dau",
    path: "/the-thao/lich-thi-dau",
    component: () => import("/home/msservice/workspace/MAYBE/STG/STG-MAYBE-V3-FE/maybe-v3-fe-stg/pages/the-thao/lich-thi-dau.vue").then(m => m.default || m)
  },
  {
    name: "tin-tuc",
    path: "/tin-tuc",
    component: () => import("/home/msservice/workspace/MAYBE/STG/STG-MAYBE-V3-FE/maybe-v3-fe-stg/pages/tin-tuc/index.vue").then(m => m.default || m)
  },
  {
    name: "vong-quay-ma-quai",
    path: "/vong-quay-ma-quai",
    component: () => import("/home/msservice/workspace/MAYBE/STG/STG-MAYBE-V3-FE/maybe-v3-fe-stg/pages/vong-quay-ma-quai/index.vue").then(m => m.default || m)
  }
]